import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchCdpWeekSpeakerPage } from '../../../staticSiteBackend/cdpWeek2024';
export var createCdpWeekSpeakerQuery = function createCdpWeekSpeakerQuery(client) {
  return [["cdpWeek2024", "SpeakerPage"], function () {
    return fetchCdpWeekSpeakerPage(client);
  }];
};
export var useSpeakersQuery = createQueryHook(createCdpWeekSpeakerQuery, useStaticSiteBackend, {
  staleTime: Infinity
});